import React, { useState, useEffect, useRef } from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import Label from "src/components/Label";
import Heading from "src/components/Heading";
import { Disclosure } from "@headlessui/react";
import Wave from "src/utils/Wave";
import PlusCircle from "src/images/plus-circle.svg";
import MinusCircle from "src/images/minus-circle.svg";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}


const Faq = (props) => {
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setHeight(ref.current.clientHeight);
  }, []);

  
  return (
    <Disclosure as="div" className="pt-4 last:border-b">
      {({ open }) => (
        <>
          <dt className="text-lg">
            <Disclosure.Button className="group flex w-full items-start justify-between text-left">
              <h3
                className={classNames(
                  open ? "text-brightgreen" :props.backgroundColor? 'text-black':"text-lightblue-200",
                  "group-hover:text-brightgreen mb-0 py-1.5 text-base font-extrabold font-display tracking-[-0.01em] duration-500 lg:text-base"
                )}
              >
                {props.title}
              </h3>
              <span className="ml-6 flex h-7 items-center">
                <div>
                  {open 
                    ? <MinusCircle className={classNames(
                      open ? "stroke-brightgreen" : "stroke-lightblue-200",
                      "group-hover:stroke-brightgreen h-6 w-6 transform transition-all duration-300 ease-in-out"
                    )}/>
                    : <PlusCircle className={classNames(
                      open ? "stroke-brightgreen" : "stroke-lightblue-200",
                      "group-hover:stroke-brightgreen h-6 w-6 transform transition-all duration-300 ease-in-out"
                    )}/>
                  } 
                </div>
              </span>
            </Disclosure.Button>
          </dt>
          <dd className="mt-2 pr-12">
            <div
              style={{ maxHeight: open ? height : 0 }}
              className={classNames(
                open ? "mb-4" : "mb-0",
                "transform overflow-hidden transition-all duration-500 ease-in-out"
              )}
            >
              <div className="prose text-base leading-6 text-darkblue-700" ref={ref}>
                <RichText>{props.content}</RichText>
              </div>
            </div>
          </dd>
        </>
      )}
    </Disclosure>
  );
};

const CenteredAccordion = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className={`${blok.remove_top_margin ? 'mb-16 md:mb-32 lg:mb-40' : 'my-16 md:my-32 lg:my-40'}`}>
        {blok.curve_top && (
          <Wave size="small" className={`${blok.backgroundColor?'fill-lightblue':'fill-white'} mt-16`} flip scale />
        )}
        <div className={`${blok.backgroundColor?'bg-lightblue':'bg-white'}  md:32 relative py-16 sm:py-20`}>
          <div className="mx-auto flex max-w-6xl flex-row flex-wrap 2xl:max-w-screen-2xl">
            <div className="mb-12 w-full max-w-md px-6 lg:w-1/2">
              <Label className={`${blok.backgroundColor?'text-black':'text-lightblue-200 before:bg-lightblue-200'}  mb-4 font-bold`} p={true}>
                {blok.label}
              </Label>
              <Heading size="h2" className={`text-600 ${blok.backgroundColor?'bg-lightblue':'text-darkblue'}`}>
                {blok.title}
              </Heading>
              <span className={`prose mt-4 block max-w-lg text-base font-normal ${blok.backgroundColor?'text-black':'text-darkblue'}`}>
                <RichText>{blok.content}</RichText>
              </span>
            </div>
            <div className="mx-auto w-full px-6 lg:w-1/2">
              <dl
                v-for="item in items"
                className="divide-lightblue-200 mt-1 space-y-1 divide-y divide-dashed last:pb-1"
              >
                {blok.items.map((faq) => (
                  <Faq {...faq} backgroundColor={blok.backgroundColor} key={faq.title}></Faq>
                ))}
              </dl>
            </div>
          </div>
        </div>
        {blok.curve_bottom && (
          <Wave size="small" className={`${blok.backgroundColor?'fill-lightblue':'fill-white'} mb-16`}scale />
        )}
      </div>
    </SbEditable>
  );
};

export default CenteredAccordion;
